"use client";

import styled from "styled-components";

//Types
import type { CustomInputProps } from "@/types";
import { NumericFormat } from "react-number-format";

export const InputComponent = styled.input<CustomInputProps>`
  background: transparent;
  height: 40px;
  width: 100%;
  border: 1px solid var(--borderColor);
  border-radius: 7px;
  box-shadow: none;
  padding: 10px;
  font-family: "Roboto Light";

  font-size: 14px;
  line-height: 24px;
  font-weight: normal;
  color: var(--titleColor);

  &:focus {
    border-color: var(--primaryAndPurple);
    box-shadow: 0px 4px 8px 1px var(--colorShadow);
    outline: none;
  }

  &:disabled {
    background: var(--lightGray);
    color: var(--placeholderColorLight);
    cursor: not-allowed;
  }

  &::placeholder {
    color: var(--placeholderColor);
  }

  ${({ $hasShadow }) =>
    $hasShadow &&
    `
        box-shadow: 0px 4px 8px 1px var(--colorShadow);
        &:focus {
            box-shadow: 0px 4px 8px 1px var(--colorShadow);
        }
    `}

  &[type="password"] {
    -webkit-text-security: disc;
    font-size: 20px; /* Aumenta o tamanho das bolinhas */
    letter-spacing: 2px; /* Dá um espaçamento maior entre as bolinhas */
  }

  ${({ validation }) =>
    validation?.type === "error" &&
    `
        border-color: var(--red)!important;
    `}
`;

export const InputPrice = styled(NumericFormat)<CustomInputProps>`
  background: transparent;
  height: 40px;
  width: 100%;
  border: 1px solid var(--borderColor);
  border-radius: 7px;
  box-shadow: none;
  padding: 10px;
  font-family: "Roboto Light";

  font-size: 14px;
  line-height: 24px;
  font-weight: normal;
  color: var(--titleColor);

  &:focus {
    border-color: var(--primaryAndPurple);
    box-shadow: 0px 4px 8px 1px var(--colorShadow);
    outline: none;
  }

  &:disabled {
    background: var(--lightGray);
    color: var(--placeholderColorLight);
    cursor: not-allowed;
  }

  &::placeholder {
    color: var(--placeholderColor);
  }

  ${({ $hasShadow }) =>
    $hasShadow &&
    `
        box-shadow: 0px 4px 8px 1px var(--colorShadow);
        &:focus {
            box-shadow: 0px 4px 8px 1px var(--colorShadow);
        }
    `}

  &[type="password"] {
    -webkit-text-security: disc;
    font-size: 20px; /* Aumenta o tamanho das bolinhas */
    letter-spacing: 2px; /* Dá um espaçamento maior entre as bolinhas */
  }

  ${({ validation }) =>
    validation?.type === "error" &&
    `
        border-color: var(--red)!important;
    `}
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  display: block;
  color: var(--red);
`;
